import type { Components } from '@mui/material'

export const OmuiChipWithActionButton: NonNullable<Components['OmuiChipWithActionButton']> = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 0,
      borderRadius: theme.shape['futureTheme.radius-sm'],
      border: `${theme.futureTheme.strokeWidth.default} solid ${theme.palette.futureTheme.border.subtle}`,
      overflow: 'hidden',
      backgroundColor: theme.palette.futureTheme.bg.neutral.muted,
      ...(ownerState?.clickable && {
        cursor: 'pointer',
        '&:hover, &:focus-within': {
          backgroundColor: theme.palette.futureTheme.bg.neutral.mutedHover,
          borderColor: theme.palette.futureTheme.border.strong,
        },
      }),
    }),
    chip: ({ theme }) => ({
      flex: '1 1 auto',
      minWidth: 0,
      paddingRight: theme.spacing(0.5),
      // Neutralise the standalone MuiChip border/background — including its clickable hover/focus
      // state — so the chip reads as part of the unified pill whose own hover lives on the root;
      // &&& beats the props-based colour variants in MuiChip.
      '&&&': {
        border: 'none',
        borderRadius: 0,
        backgroundColor: 'transparent',
        '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus-visible': {
          backgroundColor: 'transparent',
        },
      },
    }),
    actionButtonSlot: ({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      paddingRight: theme.spacing(0.5),
      '& .MuiIconButton-root': {
        padding: theme.spacing(0.5),
        color: theme.palette.futureTheme.fg.muted,
        // No separate hover circle — the whole pill shares one hover state via the root.
        '&:hover': { backgroundColor: 'transparent', color: theme.palette.futureTheme.fg.default },
      },
    }),
  },
}
